import { TenantState } from '@constants/tenant';
import React, { Dispatch, SetStateAction } from 'react';

export interface Tenant {
  name: string;
  id: string;
  key: string;
  state: TenantState;
  stateDetails?: string;
}

export const TenantContext =
React.createContext<{
  tenants: Tenant[] | null,
  setTenants: Dispatch<SetStateAction<Tenant[] | null>>,
  selectedTenant: Tenant | null,
  setSelectedTenant: Dispatch<SetStateAction<Tenant | null>>
}>({
  tenants: null,
  setTenants: () => null,
  selectedTenant: null,
  setSelectedTenant: () => null
});
